/* src/components/nav-item/nav-item.component.scss */
:host {
  display: block;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  color: inherit;
  box-sizing: inherit;
  --bg: var(--vwui-nav-item--bg,none);
  --bg-selected: var(--vwui-nav-item--bg-selected,var(--vwui--color--light));
  --color: var(--vwui-nav-item--color,var(--vwui--color--neutral-1));
  --color-selected: var(--vwui-nav-item--color-selected,var(--vwui--color--dark));
  --icon-color: var(--vwui-nav-item--icon-color,var(--color));
  --icon-color-selected: var(--vwui-nav-item--icon-color-selected,var(--vwui--color--primary));
  --padding-x: var(--vwui-nav-item--padding-x,var(--vwui--spacing--lg));
  --padding-y: var(--vwui-nav-item--padding-y,var(--vwui--spacing--md));
  --radius: var(--vwui-nav-item--radius,var(--vwui--radius--md));
  transition: all 0.15s ease-in-out 0s;
  padding-top: var(--padding-y);
  padding-bottom: var(--padding-y);
  padding-left: var(--padding-x);
  padding-right: var(--padding-x);
  margin-bottom: var(--vwui--spacing--xxs);
}
:host .nav-item {
  display: block;
  -webkit-box-align: center;
  align-items: center;
  color: var(--color);
  font-weight: var(--vwui--font--semibold);
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s ease-in-out 0s;
}
:host.is-active {
  color: var(--color-selected);
  background: var(--bg-selected);
  box-shadow: var(--vwui-shadow-base);
  border-radius: var(--radius);
  cursor: default;
}
:host.is-active .nav-item {
  color: var(--color-selected);
}
:host.is-active {
  color: var(--vwui--color--dark);
  background: var(--vwui--color--light);
  box-shadow: var(--vwui-shadow-base);
  border-radius: var(--vwui--radius--md);
  cursor: default;
}
:host__label {
  white-space: nowrap;
  text-align: center;
}
:host:hover {
  text-decoration: none;
  background: rgba(var(--vwui--color--light-rgb), 0.7);
  border-radius: var(--vwui--radius--md);
}
/*# sourceMappingURL=nav-item.component-3WPLLUL2.css.map */
